import Button from '@mui/material/Button';
import Grid from '@mui/material/GridLegacy';
import React from 'react';
import type { DownloadButtonProps } from './DownloadButton.types';

export const DownloadButtonComponent: React.FC<DownloadButtonProps> = ({
  model,
}) => {
  const download = React.useCallback(
    () => window.open(model?.target?.url),
    [model]
  );
  return (
    <Grid container justifyContent="center">
      <Grid item>
        <Button color="primary" variant="contained" onClick={download}>
          {model?.label}
        </Button>
      </Grid>
    </Grid>
  );
};
